import axios from '@/axios';

export default {
  getPatientScripts(_context, data) {
    return axios.get(`/api/v1/compounded-order/patient-scripts/${data.patientId}?clinicId=${data.clinicId}&productId=${data.productId}`);
  },
};
